import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
export function AtomError(msg, code) {
  this.errMsg = msg;
  this.errCode = code;
}

AtomError.prototype.toString = function () {
  return this.errMsg + (this.errCode ? "(".concat(this.errCode, ")") : '');
};

AtomError.BRIDGE_NOT_ALLOW = 50001;
AtomError.BRIDGE_INJECT_ERROR = 50002;
AtomError.BRIDGE_INVOKE_TIMEOUT = 50003;
AtomError.BRIDGE_INVOKE_FAIL = 50004;
AtomError.BRIDGE_INVOKE_ERROR = 50005;
AtomError.BRIDGE_LISTENER_INVALID = 50006;
AtomError.API_NOT_IMPLEMENTED = 50007;